import { render, staticRenderFns } from "./charm-rank.vue?vue&type=template&id=84f9ce02&scoped=true&"
import script from "./charm-rank.vue?vue&type=script&lang=js&"
export * from "./charm-rank.vue?vue&type=script&lang=js&"
import style0 from "./charm-rank.vue?vue&type=style&index=0&id=84f9ce02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f9ce02",
  null
  
)

export default component.exports